import { useTitle } from 'react-use';
import { connect } from 'react-redux';

import { Layout } from 'CorePackage/MainModule/components/Layout';
import { getLawInterface } from 'CorePackage/MainModule/reducers/coreReducer';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { ErknmAnalyticsProsecutorOrganization } from 'AnalyticsPackage/ErknmAnalyticsProsecutorOrganizationModule/components/ErknmAnalyticsProsecutorOrganization';

interface IAnalyticsPageStoreProps {
  isErknm: boolean;
}

const AnalyticsProsecutorOrganizationPageWithoutStore = ({ isErknm }: IAnalyticsPageStoreProps) => {
  useTitle('Аналитика');

  if (!isErknm) return null;

  return (
    <Layout withFooter>
      <ErknmAnalyticsProsecutorOrganization />
    </Layout>
  );
};

const mapStateToProps = (state: IRootState): IAnalyticsPageStoreProps => ({
  isErknm: getLawInterface(state) === LawInterfacesEnum.FZ_248,
});

export const AnalyticsProsecutorOrganizationPage = connect(mapStateToProps)(
  AnalyticsProsecutorOrganizationPageWithoutStore,
);
